define([
	"csi/def",
	"csi/reflection",
	"csi/store/Classes",
	"Export"
], function(def,reflection,Classes,Export) {

	return Classes(reflection.getClasses(), 
		function(rc) {
			return (rc.getType() != "ExportDefinition") && def.getClassViewDef(rc, Export.VIEW, false, true);
		},
		function(rc, item) {
			item.name = item.name + ' (' + rc.getType() + ')'
		}
	);
});